/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation, HashRouter } from "react-router-dom";

// @mui material components
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard React examples
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Soft UI Dashboard React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Soft UI Dashboard React routes
import routes from "routes";

// Soft UI Dashboard React contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brand from "assets/images/anmol_industries_limited_logo.jpg";
import VendorRegister from "layouts/newVendor/vendorRegistration";
import VendorForm from "layouts/VendorForm";
import VendorBusinessType from "layouts/VendorBusinessType";
import VendorFormView from "layouts/VendorFormView";
import VendorFormNext from "layouts/VendorFormNext";
import CustomerForm from "layouts/CustomerForm";
import VendorValidationFinal from "layouts/VendorValidationFinal";
import CustomerValidation from "layouts/CustomerValidation";
import { WindowRounded } from "@mui/icons-material";
import CustomerType from "layouts/CustomerType";
import CustomerValidationFinal from "layouts/CustomerValidationFinal";
import SignUp from "layouts/authentication/sign-up";
import VendorEditValidation from "layouts/VendorEditValidation";
import CustomerFormNext from "layouts/CustomerFormNext";
import VendorEditValidationFinal from "layouts/VendorEditValidationFinal";
import VendorFormEdit from "layouts/VendorFormEdit";
import VendorFormNextEdit from "layouts/VendorFormNextEdit";
import CustomerEditValidation from "layouts/CustomerEditValidation";
import CustomerEditValidationFinal from "layouts/CustomerEditValidationFinal";
import CustomerFormEdit from "layouts/CustomerFormEdit";
import CustomerFormNextEdit from "layouts/CustomerFormNextEdit";
import VendorForm2 from "layouts/VendorForm2";
import CustomerForm2 from "layouts/CustomerForm2";
import VendorForm3 from "layouts/VendorForm3";
import CustomerForm3 from "layouts/CustomerForm3";
import ChangePassword from "layouts/ChangePassword";
import ForgotPassword from "layouts/ForgotPassword";
import MaterialEdit from "layouts/MaterialEdit";
import { MenuProvider } from "newContext/MenuContext";
import VendorRework from "layouts/VendorRework";
import VendorRework2 from "layouts/VendorRework2";
import ThankYou from "layouts/ThankYou";



export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const [isVendorRoute, setIsVendorRoute] = useState(false);
  const { pathname } = useLocation();

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };


  
 

  useEffect(() => {
    if(window.location.pathname==="/vendor/validation" || window.location.pathname==="/vendor/registration-form" || window.location.pathname==="/vendor/rework"|| window.location.pathname==="/vendor/rework-2"|| window.location.pathname==="/vendor/registration-form-2" ||  window.location.pathname==="/vendor/business-type"
      || window.location.pathname==="/customer/registration-form"
      || window.location.pathname==="/vendor/form-view" || window.location.pathname=== "/vendor/validation-2"|| window.location.pathname=== "/customer/validation" || window.location.pathname==="/customer/edit/validation" || window.location.pathname==="/customer/edit/registration-form" || window.location.pathname==="/customer/edit/choose-field"
      || window.location.pathname=== "/customer/customer-type" || window.location.pathname==="/customer/validation-2" || window.location.pathname==="/vendor/edit/validation"
      || window.location.pathname=== "/customer/registration-form-2"|| window.location.pathname=== "/vendor/rework/confirm"|| window.location.pathname=== "/authentication/forgot-password" || window.location.pathname=== "/customer/edit/registration-form-2" || window.location.pathname=== "/vendor/edit/choose-field" || window.location.pathname=== "/vendor/edit/registration-form" || window.location.pathname=== "/vendor/edit/registration-form-2" 
    ) {
      setIsVendorRoute(true)
     }
  },[])

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const configsButton = (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SoftBox>
  );

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && !isVendorRoute && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="ANMOL INDUSTRIES LIMITED"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="/vendor/validation" element={<VendorRegister />} />
          <Route path="/vendor/validation-2" element={<VendorValidationFinal />} />
          <Route path="/vendor/rework" element={<VendorRework />} />
          <Route path="/vendor/rework/confirm" element={<ThankYou />} />
        <Route path="/vendor/rework-2" element={<VendorRework2 />} />
          <Route path="/vendor/registration-form" element={<VendorForm />} />
          <Route path="/vendor/registration-form-2" element={<VendorFormNext />} />
          <Route path="/vendor/edit/registration-form-2" element={<VendorFormNextEdit />} />
          <Route path="/vendor/edit-details" element={<VendorForm2 />} />
          <Route path="/vendor/approver/edit-details" element={<VendorForm3 />} />
          <Route path="/vendor/business-type" element={<VendorBusinessType />} />
          <Route path="/vendor/form-view" element={<VendorFormView />} />
          <Route path="/customer/registration-form" element={<CustomerForm />} />
          <Route path="/customer/registration-form-2" element={<CustomerFormNext />} />
          <Route path="/customer/validation" element={<CustomerValidation />} />
          <Route path="/customer/edit/validation" element={<CustomerEditValidation />} />
          <Route path="/customer/edit/registration-form" element={<CustomerFormEdit />} />
          <Route path="/customer/edit/registration-form-2" element={<CustomerFormNextEdit />} />
          <Route path="/customer/edit/choose-field" element={<CustomerEditValidationFinal />} />
          <Route path="/authentication/reset-password" element={<ChangePassword />} />
          <Route path="/authentication/forgot-password" element={<ForgotPassword />} />
          <Route path="/customer/edit-details" element={<CustomerForm2 />} />
          <Route path="/customer/approver/edit-details" element={<CustomerForm3 />} />
          <Route path="/customer/customer-type" element={<CustomerType />} />
          <Route path="/customer/validation-2" element={<CustomerValidationFinal />} />
          <Route path="/vendor/edit/validation" element={<VendorEditValidation />} />
          <Route path="/vendor/edit/choose-field" element={<VendorEditValidationFinal />} />
          <Route path="/vendor/edit/registration-form" element={<VendorFormEdit />} />
          <Route path="/material/edit" element={<MaterialEdit />} />
          {/* <Route path="/authentication/sign-up" element={<SignUp />} /> */}
          {/* <Route path="/vendor-form" element={<VendorForm />} /> */}
          <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
   

    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && !isVendorRoute && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={brand}
            brandName="MDM Portal"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="/vendor/validation" element={<VendorRegister />} />
        <Route path="/vendor/validation-2" element={<VendorValidationFinal />} />
        <Route path="/vendor/registration-form" element={<VendorForm />} />
        <Route path="/vendor/rework" element={<VendorRework />} />
        <Route path="/vendor/rework/confirm" element={<ThankYou />} />
        <Route path="/vendor/rework-2" element={<VendorRework2 />} />
        <Route path="/vendor/registration-form-2" element={<VendorFormNext />} />
        <Route path="/vendor/edit/registration-form-2" element={<VendorFormNextEdit />} />
        <Route path="/vendor/business-type" element={<VendorBusinessType />} />
        <Route path="/vendor/form-view" element={<VendorFormView />} />
        <Route path="/customer/registration-form" element={<CustomerForm />} />
        <Route path="/customer/registration-form-2" element={<CustomerFormNext />} />
        <Route path="/vendor/edit-details" element={<VendorForm2 />} />
        <Route path="/vendor/approver/edit-details" element={<VendorForm3 />} />
        <Route path="/customer/validation" element={<CustomerValidation />} />
        <Route path="/customer/edit/validation" element={<CustomerEditValidation />} />
        <Route path="/customer/edit/registration-form" element={<CustomerFormEdit />} />
        <Route path="/authentication/reset-password" element={<ChangePassword />} />
        <Route path="/authentication/forgot-password" element={<ForgotPassword />} />
        <Route path="/customer/edit/registration-form-2" element={<CustomerFormNextEdit />} />
        <Route path="/customer/edit/choose-field" element={<CustomerEditValidationFinal />} />
        <Route path="/customer/edit-details" element={<CustomerForm2 />} />
        <Route path="/customer/approver/edit-details" element={<CustomerForm3 />} />
        <Route path="/customer/customer-type" element={<CustomerType />} />
        <Route path="/customer/validation-2" element={<CustomerValidationFinal />} />
        <Route path="/vendor/edit/validation" element={<VendorEditValidation />} />
        <Route path="/vendor/edit/choose-field" element={<VendorEditValidationFinal />} />
        <Route path="/vendor/edit/registration-form" element={<VendorFormEdit />} />
        <Route path="/material/edit" element={<MaterialEdit />} />
        {/* <Route path="/authentication/sign-up" element={<SignUp />} /> */}
        <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
        {/* <Route path="/vendorRegister" element={<Navigate to="/newVendor/vendor-register" />} /> */}
      </Routes>
    </ThemeProvider>
   
  );
}
